import { create } from 'zustand';
import type { Dialog } from './types';

export function createDialogStore<T extends object>() {
    return create<Dialog<T>>((set) => ({
        actions: {
            add: (data?: T) => {
                set({
                    state: {
                        data: data ?? null,
                        mode: 'add',
                        open: true,
                    },
                });
            },

            close: () => {
                set({
                    state: {
                        data: null,
                        mode: null,
                        open: false,
                    },
                });
            },

            edit: (data: T) => {
                set({
                    state: {
                        data,
                        mode: 'edit',
                        open: true,
                    },
                });
            },

            open: (data: T) => {
                set({
                    state: {
                        data,
                        mode: 'open',
                        open: true,
                    },
                });
            },

            setState: (nextState) => {
                set(({ state }) => ({
                    state: typeof nextState === 'function' ? nextState(state) : nextState,
                }));
            },
        },
        state: {
            data: null,
            mode: null,
            open: false,
        },
    }));
}
